import React from 'react';

const ButtonLink = ({ onClick, children, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={`text-blue-500 hover:underline focus:outline-none ${className}`}
    >
      {children}
    </button>
  );
};

export default ButtonLink;
